module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4>'+
((__t=( i18n.tc( "UnitComplaint", "Change of device" ) ))==null?'':__t)+
'</h4><hr><div data-region="complaint-container"></div>';
}
return __p;
};
